import React from 'react';
import './NADWaiverSectionMessage.styles.scss';

export type NADWaiverMessageType = 'error' | 'empty';

interface NADWaiverSectionMessageProps {
  type: NADWaiverMessageType;
  message: string;
}

/**
 * Empty or error state for the NAD Waiver section.
 * Renders inside the same section skeleton (narrative-box) to maintain layout.
 */
const NADWaiverSectionMessage: React.FC<NADWaiverSectionMessageProps> = ({
  type,
  message,
}) => {
  return (
    <section
      className={`narrative-box nad-waiver-box nad-waiver-section-message nad-waiver-section-message--${type}`}
    >
      <h4 className="narrative-box-text-title">
        <i className="pi pi-file-edit" style={{ marginRight: '0.5rem' }} />
        NAD Waiver
      </h4>
      <div className="nad-waiver-section-message__content">
        {type === 'error' && (
          <i className="pi pi-exclamation-triangle nad-waiver-section-message__icon" />
        )}
        {type === 'empty' && (
          <i className="pi pi-inbox nad-waiver-section-message__icon" />
        )}
        <p className="nad-waiver-section-message__text">{message}</p>
      </div>
    </section>
  );
};

export default NADWaiverSectionMessage;
